import validate from "/app/node_modules/nuxt/dist/pages/runtime/validate.js";
import _2_45auth_45global from "/app/middleware/2.auth.global.js";
import _3_45fetch_45all_45feature_45flags_45global from "/app/middleware/3.fetchAllFeatureFlags.global.js";
import _4_45fetch_45user_45details_45global from "/app/middleware/4.fetchUserDetails.global.js";
import _5_45to_45cached_45path_45global from "/app/middleware/5.toCachedPath.global.js";
import manifest_45route_45rule from "/app/node_modules/nuxt/dist/app/middleware/manifest-route-rule.js";
export const globalMiddleware = [
  validate,
  _2_45auth_45global,
  _3_45fetch_45all_45feature_45flags_45global,
  _4_45fetch_45user_45details_45global,
  _5_45to_45cached_45path_45global,
  manifest_45route_45rule
]
export const namedMiddleware = {
  "check-carrier-profile-by-role": () => import("/app/middleware/checkCarrierProfileByRole.js"),
  "check-url-for-job-ids": () => import("/app/middleware/checkUrlForJobIds.js"),
  "edit-job": () => import("/app/middleware/editJob.js"),
  "get-carrier-fleet": () => import("/app/middleware/getCarrierFleet.js"),
  "get-carrier-users": () => import("/app/middleware/getCarrierUsers.js"),
  "get-recommended-jobs-from-url": () => import("/app/middleware/getRecommendedJobsFromUrl.js"),
  "manage-jobs": () => import("/app/middleware/manageJobs.js"),
  "special-announcement": () => import("/app/middleware/specialAnnouncement.js"),
  "staged-job-count": () => import("/app/middleware/stagedJobCount.js"),
  "validate-user-account-level": () => import("/app/middleware/validateUserAccountLevel.js"),
  "validate-user-role": () => import("/app/middleware/validateUserRole.js")
}